import { FlatList } from "react-native-gesture-handler";
import OpacityView from "src/components/OpacityView";
import { paddingMedium } from "src/styles/spacing";
import { SearchModalPaddingHorizontal } from "../../constants/SearchModalStyleConstants";
import { SearchCommunityType } from "../../types";
import SearchCommunityItem from "./components/SearchCommunityItem";
import { SEARCH_COMMUNITY_SPACING } from "./constants";

const SearchCommunities = ({ communities }: { communities: SearchCommunityType[] }) => {
	return (
		<OpacityView
			style={{
				width: "100%",
				marginTop: paddingMedium,
			}}
		>
			<FlatList
				horizontal
				keyboardDismissMode="on-drag"
				data={communities}
				renderItem={({ item }) => <SearchCommunityItem item={item} />}
				showsHorizontalScrollIndicator={false}
				contentContainerStyle={{
					paddingHorizontal: SearchModalPaddingHorizontal - SEARCH_COMMUNITY_SPACING,
				}}
				keyExtractor={(item) => item.communityId}
			/>
		</OpacityView>
	);
};
export default SearchCommunities;
